const FALLBACK_BASE_NAME = 'resume';

/** Keeps letters, digits, spaces and underscores and always appends `.pdf`, so a stray `.` in a name is never read as the file extension. */
export function toPdfFileName(baseName: string): string {
  const sanitized = baseName
    .replace(/\s+/g, ' ')
    .replace(/[^\p{L}\p{M}\p{N} _]/gu, '')
    .replace(/_{2,}/g, '_')
    .replace(/ {2,}/g, ' ')
    .replace(/^[ _]+|[ _]+$/g, '');

  return `${sanitized || FALLBACK_BASE_NAME}.pdf`;
}
